import { useCallback, useEffect, useState } from "react";

import careBalanceService from '../../../services/careBalanceService';

export default function useCareBalance({ hmoId }) {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchWallet = useCallback((hmoId) => {
    setLoading(true);

   careBalanceService
      .getWallet(hmoId)
      .then(({data}) => {
        setWallet(data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (!hmoId) {
      return;
    }

    fetchWallet(hmoId);
  }, [fetchWallet, hmoId]);

  return { wallet, loading, fetchWallet, setLoading };
}
